module.exports = __webpack_public_path__ + "static/defaultRestaurantPin-7ba10ba7730e94189f878cda1f03b6c1.png";